import { useQuery } from '@tanstack/react-query';
import { aiInsightsApi } from '../api';

// Deal scores reuse the EXISTING canonical Deals cache (['deals','ai-scores']).
// Re-exported here so the AI namespace exposes it without a second request.
export { useDealScores } from '@/features/deals/hooks/useDeals';
// Deals list cache reused for joining titles/stages to scores.
export { useDeals } from '@/features/deals/hooks/useDeals';

const FIVE_MINUTES = 5 * 60 * 1000;

export function useBriefing() {
  return useQuery({
    queryKey: ['ai', 'briefing'],
    queryFn: async () => (await aiInsightsApi.briefing()).insights ?? [],
    staleTime: FIVE_MINUTES,
  });
}

export function useLeadScores() {
  return useQuery({
    queryKey: ['ai', 'lead-scores'],
    queryFn: async () => (await aiInsightsApi.leadScores()).scores ?? [],
    staleTime: FIVE_MINUTES,
  });
}

export function useCallOptimizer() {
  return useQuery({
    queryKey: ['ai', 'call-optimizer'],
    queryFn: aiInsightsApi.callOptimizer,
    staleTime: FIVE_MINUTES,
  });
}

export function useNicheIntelligence() {
  return useQuery({
    queryKey: ['ai', 'niche-intelligence'],
    queryFn: async () => (await aiInsightsApi.nicheIntelligence()).niches ?? [],
    staleTime: FIVE_MINUTES,
  });
}

export function useAnomalies() {
  return useQuery({
    queryKey: ['ai', 'anomalies'],
    queryFn: async () => (await aiInsightsApi.anomalies()).anomalies ?? [],
    staleTime: FIVE_MINUTES,
  });
}

export function useScrapeAdvisor() {
  return useQuery({
    queryKey: ['ai', 'scrape-advisor'],
    queryFn: aiInsightsApi.scrapeAdvisor,
    staleTime: FIVE_MINUTES,
  });
}
